import { useSceneEntities } from "@/stores/SceneEntities";
export function useAssetTub2653Door(payload, viewport) {
  const sceneEntities = useSceneEntities();  

  viewport.invalidateTransformForKey("elite_2653_tub_door","elite_2653_tub_door_open");
}
